import { Component, OnInit, OnDestroy } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { LocationsTurnsService } from 'src/app/services/turns-services/locations-turns-service/locations-turns.service';

@Component({
  selector: 'app-turns-parameters-dashboard',
  templateUrl: './turns-parameters-dashboard.component.html',
  styleUrls: ['./turns-parameters-dashboard.component.scss']
})
export class TurnsParametersDashboardComponent implements OnInit, OnDestroy {

  locations;
  getSMSsSubscription: Subscription;
  getTicketsSubscription: Subscription;
  getLocationsSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
              private locationsTurnsService: LocationsTurnsService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getLocations();
  }

  private getLocations() {
    this.getLocationsSubscription = this.locationsTurnsService.getLocationList().subscribe(
      (res) => {
        if (res) {
          this.locations = res;
        }
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-receipt', 'turns-page.parameters', '/turns', [new BRoute('turns-page.turns', '/turns'), new BRoute('turns-page.parameters')]));
  }

  ngOnDestroy() {
    if (this.getLocationsSubscription) { this.getLocationsSubscription.unsubscribe(); }
  }
}
